import React from 'react';
import './UpdatePrompt.css';

interface UpdatePromptProps {
  isOpen: boolean;
  currentVersion: string;
  latestVersion: string;
  onUpdate: () => void;
  onDismiss: () => void;
}

export const UpdatePrompt: React.FC<UpdatePromptProps> = ({
  isOpen,
  currentVersion,
  latestVersion,
  onUpdate,
  onDismiss,
}) => {
  if (!isOpen) return null;

  return (
    <div className="update-prompt-overlay">
      <div className="update-prompt-modal">
        <div className="update-icon">📜</div>
        <h2 className="update-title">发现新版本</h2>
        <div className="update-version">
          <span>v{currentVersion}</span>
          <span className="arrow">→</span>
          <span>v{latestVersion}</span>
        </div>
        <p className="update-description">
          游戏已更新，包含新功能和优化。<br />
          点击更新获取最新体验。
        </p>
        <div className="update-actions">
          <button
            className="update-btn-secondary"
            onClick={onDismiss}
          >
            稍后提醒
          </button>
          <button
            className="update-btn-primary"
            onClick={onUpdate}
          >
            立即更新
          </button>
        </div>
      </div>
    </div>
  );
};
